import { errorStates } from "@hz/common/constants";

import { AlertTriangle } from "lucide-react";

import { Group, Heading, HStack, Link, Text } from "@chakra-ui/react";

import { Button } from "@components/ui/button";

import ErrorInfoBox from "./components/error-info-box";
import type { ErrorScreenProps } from "./types";

const NO_PERMISSION_SCREEN = ({ type, errorDetails, eventId, email, onRetry }: ErrorScreenProps) => {
  const mailToLink = `mailto:support@stackfully.co?subject=Error%20Report&body=${encodeURIComponent(
    `Hi Stackfully team,\n\nA ${errorStates.NO_PERMISSION} occurred with the following details:\n\n${errorDetails}\n\nThank you.`,
  )}`;

  return (
    <Group flexDirection="column">
      <AlertTriangle
        size={48}
        className="text-red-500"
      />
      <Heading size="xl">{"Access Denied"}</Heading>
      <Text color="gray.600">
        Your Xero for monday.com user doesn’t have permission to access this resource. Please check your
        permissions with your monday Admin or contact{" "}
        <Link
          href={mailToLink}
          color="blue.500"
          textDecoration="none"
        >
          {email}
        </Link>{" "}
        for assistance.
      </Text>

      <ErrorInfoBox
        type={type}
        errorDetails={errorDetails}
        eventId={eventId}
      />

      <HStack>
        <Button
          colorPalette="blue"
          size="lg"
          onClick={onRetry}
          mt="4px"
        >
          Retry
        </Button>
      </HStack>
    </Group>
  );
};

export default NO_PERMISSION_SCREEN;
